// pages/ContactSupport.js
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ContactSupport = () => {
  const { t } = useTranslation();
  const [copySuccess, setCopySuccess] = useState('');
  const emailAddress = 'contact@janney.ai';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopySuccess(t('email_copied'));
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess(t('copy_failed'));
    }
  };

  return (
    <div className="container mt-5 mb-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card shadow-lg border-0">
            <div className="card-body p-5">
              <h1 className="text-center mb-4 display-5 fw-bold text-primary">
                {t('contact_support')}
              </h1>
              
              <div className="text-center mb-5">
                <p className="lead text-muted">
                  {t('contact_support_description')}
                </p>
              </div>

              <div className="contact-methods">
                <div className="method-item mb-5 p-4 bg-light rounded-3">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-envelope-fill fs-2 text-primary me-3"></i>
                    <h3 className="mb-0 h4">{t('email_support')}</h3>
                  </div>
                  <p className="text-muted mb-4">{t('email_support_description')}</p>
                  <div className="d-flex align-items-center gap-3">
                    <div className="input-group">
                      <input 
                        type="text" 
                        className="form-control bg-white" 
                        value={emailAddress} 
                        readOnly
                      />
                      <button 
                        className="btn btn-primary d-flex align-items-center gap-2" 
                        onClick={handleCopy}
                      >
                        <i className="bi bi-clipboard"></i>
                        {t('copy')}
                      </button>
                    </div>
                    <a 
                      href={`mailto:${emailAddress}`} 
                      className="btn btn-outline-primary d-flex align-items-center gap-2"
                    >
                      <i className="bi bi-send"></i>
                      {t('send_email')}
                    </a>
                  </div>
                  {copySuccess && (
                    <div className="text-success mt-2 small">
                      <i className="bi bi-check-circle me-1"></i>
                      {copySuccess}
                    </div>
                  )}
                </div>

                <div className="method-item mb-4 p-4 bg-light rounded-3">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-clock-fill fs-2 text-primary me-3"></i>
                    <h3 className="mb-0 h4">{t('response_time')}</h3>
                  </div>
                  <p className="text-muted mb-0">{t('response_time_description')}</p>
                </div>

                <div className="method-item p-4 bg-light rounded-3">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-info-circle-fill fs-2 text-primary me-3"></i>
                    <h3 className="mb-0 h4">{t('additional_info')}</h3>
                  </div>
                  <p className="text-muted mb-0">{t('additional_info_description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .card {
            transition: transform 0.2s;
            border-radius: 1rem;
          }
          
          .method-item {
            transition: transform 0.2s, box-shadow 0.2s;
            border: 1px solid rgba(0,0,0,0.05);
          }
          
          .method-item:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(0,0,0,0.1);
          }

          .btn {
            padding: 0.5rem 1rem;
            font-weight: 500;
          }

          .form-control {
            padding: 0.5rem 1rem;
            font-size: 1rem;
          }

          .input-group {
            flex: 1;
          }

          @media (max-width: 576px) {
            .d-flex.align-items-center.gap-3 {
              flex-direction: column;
            }
            
            .input-group {
              width: 100%;
            }
            
            a.btn {
              width: 100%;
              justify-content: center;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ContactSupport;